// extracted by mini-css-extract-plugin
module.exports = {"ingress":"resources_ingress__CCcEZ","resourcesContainer":"resources_resourcesContainer__JKByH"};